<app-spinner></app-spinner>
<div class="page-content fade-in-up">
  <br>
  <!-- <div class="row">
    <div class="col-3">
    <button style="margin-left:1%;" class="btn btn-link" (click)="back()"><i class="fa fa-arrow-left"
        aria-hidden="true"></i>{{mainService.allLableShowObj[mainService.language_cd+'PROFILE34']}}</button>
  </div>
</div> -->
  <div class="row">

    <div class="col-lg-12 col-md-12">

      <div class="ibox" style="background-color: white;">
        <br>
        <div class="ibox-head">
          <div class="ibox-title">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE2']}}</div>
        </div>
        <div class="ibox-body">
          <ul class="nav nav-tabs tabs-line">
            <li class="nav-item">
              <a class="nav-link active" href="#tab-1" data-toggle="tab"><i class="ti-bar-chart"></i>
                {{mainService.allLableShowObj[mainService.language_cd+'PROFILE3']}}</a>
            </li>
            <!-- <li class="nav-item">
               <a class="nav-link" href="#tab-5" data-toggle="tab"><i class="fa fa-users"></i> Establishment Info</a>
          </li> -->
            <li class="nav-item">
              <a class="nav-link" href="#tab-2" data-toggle="tab"><i class="ti-settings"></i>
                {{mainService.allLableShowObj[mainService.language_cd+'PROFILE4']}}</a>
            </li>
            <li class="nav-ite m">
              <a class="nav-link" href="#tab-3" data-toggle="tab"><i class="ti-announcement"></i>
                {{mainService.allLableShowObj[mainService.language_cd+'PROFILE5']}} </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#tab-4" data-toggle="tab"><i class="ti-announcement"></i>
                {{mainService.allLableShowObj[mainService.language_cd+'PROFILE6']}} </a>
            </li>
            <li class="nav-item back-btn-tab">
              <button class="btn btn-link fs-5" (click)="back()">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                {{mainService.allLableShowObj[mainService.language_cd+'PROFILE34']}}
              </button>
            </li>


          </ul>

          <div class="tab-content">
            <div class="tab-pane fade show active" id="tab-1">
              <div class="row">
                <div class="col-12 text-center">
                  <img [src]="imgURL" class="img-circle" width="100px" height="100px" />

                </div>

              </div>
              <br>
              <div class="row my-3">
                <div class="col-12 text-center">
                  <h5 class="font-strong  m-b-10 m-t-10">{{userInfoObj['party_name']}}</h5>
                  <div class="m-b-20 text-muted">({{roles}})</div>
                </div>
              </div>

              <br>
              <div class="user-info-wrapper mx-md-1">
                <div class="row my-3 align-items-center text-center text-md-start">
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-3">
                    <h5 style="font-weight: 500;">Party Id</h5>
                  </div>
                  <div class="col-12 col-md-1 text-center d-none d-md-block">:</div>
                  <div class="col-12 col-md-3">
                    <label style="font-weight: 500; font-size: 16px;">{{ userInfoObj['le_id'] }}</label>
                  </div>
                  <div class="col-12 col-md-2 d-none d-md-block"></div>
                </div>

                <div class="row my-3 align-items-center text-center text-md-start">
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-3">
                    <h5 style="font-weight: 500;">Emp Id</h5>
                  </div>
                  <div class="col-12 col-md-1 text-center d-none d-md-block">:</div>
                  <div class="col-12 col-md-3">
                    <label style="font-weight: 500; font-size: 16px;">{{ userInfoObj['emp_id'] }}</label>
                  </div>
                  <div class="col-12 col-md-2 d-none d-md-block"></div>
                </div>

                <div class="row my-3 align-items-center text-center text-md-start">
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-3">
                    <h5 style="font-weight: 500;">
                      {{ mainService.allLableShowObj[mainService.language_cd + 'PROFILE7'] }}
                    </h5>
                  </div>
                  <div class="col-12 col-md-1 text-center d-none d-md-block">:</div>
                  <div class="col-12 col-md-3 text-left">
                    <label style="font-weight: 500; font-size: 16px;">{{ userInfoObj['contact_email'] }}</label>
                  </div>
                  <div class="col-12 col-md-2 d-none d-md-block"></div>
                </div>

                <div class="row my-3 align-items-center text-center text-md-start">
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-3">
                    <h5 style="font-weight: 500;">
                      {{ mainService.allLableShowObj[mainService.language_cd + 'PROFILE8'] }}
                    </h5>
                  </div>
                  <div class="col-12 col-md-1 text-center d-none d-md-block">:</div>
                  <div class="col-12 col-md-3">
                    <label style="font-weight: 500; font-size: 16px;">{{ userInfoObj['phone_no'] }}</label>
                  </div>
                  <div class="col-12 col-md-2 d-none d-md-block"></div>
                </div>

                <div class="row my-3 align-items-center text-center text-md-start">
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-3">
                    <h5 style="font-weight: 500;">Date Of Birth</h5>
                  </div>
                  <div class="col-12 col-md-1 text-center d-none d-md-block">:</div>
                  <div class="col-12 col-md-3">
                    <label style="font-weight: 500; font-size: 16px;">{{ userInfoObj['party_dob'] }}</label>
                  </div>
                  <div class="col-12 col-md-2 d-none d-md-block"></div>
                </div>
              </div>


            </div>
            <div class="tab-pane fade" id="tab-2">
              <div class="container py-4">
                <h4 class="text-center mb-4">Update Profile</h4>

                <form (ngSubmit)="updateEmpInfo(profileForm)" #profileForm="ngForm">
                  <!-- Party Name -->
                  <div class="row mb-4">
                    <div class="col-md-2 offset-md-2 d-flex d-md-block align-items-center label-wrap">
                      <label for="party_name" class="form-label" style="font-weight: 500; font-size: 16px;">
                        {{ mainService.allLableShowObj[mainService.language_cd + 'PROFILE14'] }}
                      </label>
                      <span class="colon d-md-none">:</span>
                    </div>
                    <div class="col-md-1 text-center d-none d-md-block">:</div>
                    <div class="col-md-4">
                      <input type="text" id="party_name" class="form-control" [(ngModel)]="updateObj['party_name']"
                        name="party_name" placeholder="Enter Employee Name" required #partyName="ngModel">
                      <div *ngIf="profileForm.submitted && partyName.errors?.['required']" class="text-danger mt-1">
                        Employee Name is required.
                      </div>
                    </div>
                  </div>


                  <!-- Contact Email -->
                  <!-- Contact Email -->
<div class="row mb-4">
  <div class="col-md-2 offset-md-2 d-flex d-md-block align-items-center label-wrap">
    <label for="contact_email" class="form-label" style="font-weight: 500; font-size: 16px;">
      {{ mainService.allLableShowObj[mainService.language_cd + 'PROFILE15'] }}
    </label>
    <span class="colon d-md-none">:</span>
  </div>
  <div class="col-md-1 text-center d-none d-md-block">:</div>

  <div class="col-md-4">
    <input type="email" class="form-control" placeholder="Enter Email Address"
      [(ngModel)]="updateObj['contact_email']" name="contact_email" required
      [disabled]="emailVerified" #contactEmail="ngModel" email
      (ngModelChange)="checkEmail(contactEmail.value)">
    <div *ngIf="profileForm.submitted && contactEmail.errors?.['required']" class="text-danger mt-1">
      Email Address is required.
    </div>
    <ng-container *ngIf="profileForm.submitted && spanAvi == false">
      <span class="text-danger"><i>Enter Valid Email</i></span>
    </ng-container>
  </div>
</div>

<!-- Phone Number -->
<div class="row mb-4">
  <div class="col-md-2 offset-md-2 d-flex d-md-block align-items-center label-wrap">
    <label for="phone_no" class="form-label" style="font-weight: 500; font-size: 16px;">
      {{ mainService.allLableShowObj[mainService.language_cd + 'PROFILE16'] }}
    </label>
    <span class="colon d-md-none">:</span>
  </div>
  <div class="col-md-1 text-center d-none d-md-block">:</div>

  <div class="col-md-4">
    <input type="text" class="form-control" placeholder="Enter Phone Number"
      [(ngModel)]="updateObj['phone_no']" name="phone_no" minlength="10" maxlength="10"
      pattern="^[0-9]{10}$" required [disabled]="phoneVerified" #phoneNo="ngModel">
    <div *ngIf="profileForm.submitted" class="mt-1">
      <div class="text-danger" *ngIf="phoneNo.errors?.['minlength'] || phoneNo.errors?.['maxlength']">
        Mobile number must be exactly 10 digits.
      </div>
      <div class="text-danger" *ngIf="phoneNo.errors?.['required']">
        Mobile number is required.
      </div>
    </div>
  </div>
</div>


                  <!-- Submit Button -->
                  <div class="row">
                    <div class="col-12 text-center">
                      <button class="btn btn-primary" type="submit">
                        {{mainService.allLableShowObj[mainService.language_cd+'PROFILE17']}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="tab-pane fade" id="tab-3">
              <br>
              <div class="container">
                <h2>Change Password</h2>
                <br>
                <form #passwordForm="ngForm" (ngSubmit)="updatePassword(passwordForm)">
                  <!-- Old Password -->
                  <div class="form-group">
                    <label for="oldPassword">
                      <h6 style="width:100%;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE18']}}:</h6>
                    </label>
                    <div class="d-flex">
                      <input [type]="showOldPassword ? 'text' : 'password'" id="oldPassword" name="oldPassword"
                        class="form-control" [(ngModel)]="pass.oldident_verify_secret" #oldPassword="ngModel" required
                        placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE22']}}"
                        oncopy="return false;" onpaste="return false;" oncut="return false;">
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary" *ngIf="pass.oldident_verify_secret"
                          (click)="togglePasswordVisibility('old')">
                          {{ showOldPassword ? '👁️' : '🔒' }}
                        </button>
                      </div>
                    </div>
                    <div *ngIf="passwordForm.submitted">
                      <small class="text-danger" *ngIf="oldPassword.errors?.['required']">
                        Current Password is required.
                      </small>
                    </div>
                  </div>

                  <!-- New Password -->
                  <div class="form-group">
                    <label for="newPassword">
                      <h6 style="width:100%;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE19']}}:</h6>
                    </label>
                    <div class="d-flex">
                      <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword"
                        class="form-control" [(ngModel)]="pass.ident_verify_secret" #newPassword="ngModel" required
                        minlength="8" maxlength="50" (keyup)="checkPersonalInfo()"
                        pattern="^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$"
                        placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE19']}}"
                        oncopy="return false;" onpaste="return false;" oncut="return false;">
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary" *ngIf="pass.ident_verify_secret"
                          (click)="togglePasswordVisibility('new')">
                          {{ showNewPassword ? '👁️' : '🔒' }}
                        </button>
                      </div>
                    </div>
                    <div *ngIf="passwordForm.submitted">
                      <small class="text-danger" *ngIf="newPassword.errors?.['required']">
                        New Password is required.
                      </small>
                      <small class="text-danger" *ngIf="newPassword.errors?.['minlength']">
                        Password must be at least 8 characters long.
                      </small>
                      <small class="text-danger" *ngIf="newPassword.errors?.['maxlength']">
                        Password must be at most 50 characters long.
                      </small>
                      <small class="text-danger" *ngIf="newPassword.errors?.['pattern']">
                        Password must contain at least 1 uppercase letter, 1 number, and 1 special character.
                      </small>
                      <small class="text-danger"
                        *ngIf="pass.oldident_verify_secret && pass.oldident_verify_secret === pass.ident_verify_secret">
                        New password cannot be the same as the Current password.
                      </small>
                      <small class="text-danger" *ngIf="containsPersonalInfo">
                        Password should not contain your name, mobile number, or email address.
                      </small>
                    </div>
                  </div>

                  <!-- Confirm Password -->
                  <div class="form-group">
                    <label for="confirmPassword">
                      <h6 style="width:100%;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE20']}}:</h6>
                    </label>
                    <div class="d-flex">
                      <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                        name="confirmPassword" class="form-control" [(ngModel)]="pass.c_ident_verify_secret"
                        #confirmPassword="ngModel" required
                        placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE20']}}"
                        oncopy="return false;" onpaste="return false;" oncut="return false;">
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary" *ngIf="pass.c_ident_verify_secret"
                          (click)="togglePasswordVisibility('confirm')">
                          {{ showConfirmPassword ? '👁️' : '🔒' }}
                        </button>
                      </div>
                    </div>
                    <div *ngIf="passwordForm.submitted">
                      <small class="text-danger" *ngIf="confirmPassword.errors?.['required']">
                        Confirm Password is required.
                      </small>
                      <small class="text-danger"
                        *ngIf="pass.ident_verify_secret && pass.ident_verify_secret !== pass.c_ident_verify_secret">
                        Confirm password must match the new password.
                      </small>
                    </div>
                  </div>
                  <br>
                  <button type="reset" class="btn btn-danger" id="resetForm">Resest</button> &nbsp;
                  <button type="submit" class="btn btn-primary">
                    {{mainService.allLableShowObj[mainService.language_cd+'PROFILE17']}}
                  </button>
                </form>
                <br>
                <br>
                <div class="row">
                  <div class="col-12">
                    <h4>Instructions</h4>
                  </div>
                  <div class="col-12">
                    <ul>
                      <li>Password must be at least 8 characters long.</li>
                      <li>Password must contain at least 1 uppercase letter, 1 number, and 1 special character.</li>
                      <li>Password should not contain your name, mobile number, or email address.</li>
                      <li>New password cannot be the same as the Current password.</li>
                      <li>Confirm password must match the new password</li>
                    </ul>
                  </div>

                </div>
              </div>






              <!-- <div class="row">
              <div class="col-3"></div>
              <div class="col-3 ">
                <h6 style="margin-left:2% ;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE18']}}:</h6>
              </div>
              <div class="col-3">
                <input type="password"
                  placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE22']}}"
                  class="form-control" [(ngModel)]="pass['oldident_verify_secret']">
              </div>
              <div class="col-3"></div>
            </div>
            <br>
            <div class="row">
              <div class="col-3"></div>
              <div class="col-3 ">
                <h6 style="margin-left:2% ;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE19']}}:</h6>
              </div>
              <div class="col-3">
                <input type="password"
                  placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE19']}}"
                  class="form-control" [(ngModel)]="pass['ident_verify_secret']">
              </div>
              <div class="col-3"></div>

            </div>
            <br>
            <div class="row">
              <div class="col-3"></div>

              <div class="col-3 ">
                <h6 style="margin-left:2% ;">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE20']}}:</h6>
              </div>
              <div class="col-3">
                <input type="password"
                  placeholder="{{mainService.allLableShowObj[mainService.language_cd+'PROFILE20']}}"
                  class="form-control" [(ngModel)]="pass['c_ident_verify_secret']">
              </div>
              <div class="col-3"></div>

            </div>
            <br>
            <div class="row">
              <div class="col-12 text-center">
                <button class="btn btn-primary"
                  (click)="updatePassword()">{{mainService.allLableShowObj[mainService.language_cd+'PROFILE17']}}</button>
              </div>
            </div> -->
            </div>
            <div class="tab-pane fade" id="tab-4">
              <br>
              <div class="row">
                <div class="col-12  text-center">
                  <img [src]="imgURL" class="img-circle" width="150" height="150">
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-6" style="margin-left: 20%">
                  <input #file type="file" accept=".png, .jpg, .jpeg" name="pimage" ng2FileSelect [uploader]="uploader"
                    class="form-control" style="border-color: black" (change)="onFileUpload($event,file.files)">
                </div>
                <div class="col-3">
                  <button type="button" [disabled]="!uploader.getNotUploadedItems().length" class="btn btn-info"
                    (click)='Upload()'><i class="fa fa-upload"
                      aria-hidden="true">&nbsp;</i>{{mainService.allLableShowObj[mainService.language_cd+'PROFILE21']}}</button>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="tab-5">
              <br>
              <div class="row">
                <div class="col-12 text-end">
                  <button class="btn btn-primary" (click)="print1()">PRINT</button>
                </div>
              </div>

              <div id="p">
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Legal Name :</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['emp_name']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Employee ID</h6>
                  </div>
                  <div class="col-3">
                    VDA{{getNumberFormat(personalInfoObj['emp_id'])}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Bank Account No:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['acct_no']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Adhar No:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['emp_adhar_no']}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">DOB:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['emp_dob']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Email:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['emp_email']}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Father/Husband Name:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['emp_father_name']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Identification Mark:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['identification_mark']}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Joining Date:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['joining_date']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;"> Joining Of Service Date:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['joining_service_date']}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <h6 style="margin-left:2%;">Marital Status:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['marital_status']}}
                  </div>
                  <div class="col-3">
                    <h6 style="margin-left:2%;">PF Account No:</h6>
                  </div>
                  <div class="col-3">
                    {{personalInfoObj['pf_status_no']}}
                  </div>
                </div>
                <br>
                <br>
                <table class="table" style="border: black;">
                  <thead class="thead-light">
                    <tr>
                      <th>DESIGNATION</th>

                      <th>CLASS
                      </th>
                      <th>GRADE PAY
                      </th>
                      <th>PAY BAND
                      </th>
                      <th>LEVEL
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ob of estabInfo">
                      <td>
                        <h6>{{ob['designation_code']}}</h6>
                      </td>
                      <td>
                        <h6>{{ob['class_code']}}</h6>
                      </td>
                      <td>
                        <h6>{{ob['grade_pay_code']}}</h6>
                      </td>
                      <td>
                        <h6>{{ob['pay_scale_code']}}</h6>
                      </td>
                      <td>
                        <h6>{{ob['level_code']}}</h6>
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner>Loading...</ngx-spinner>